export default {
  data() {
    return {};
  },

  methods: {
    setCompMessage(compVar, type, message) {
      compVar.type = type;
      compVar.textKey = message;
    },

    clearCompMessage(compVar) {
      compVar.textKey = '';
      compVar.type = '';
    },
  },
};
